import { AppConfigModel } from "../../abstract/app-config.model";

export class ChequeRefusalReason extends AppConfigModel {

    static override CLASS_NAME: string = 'ChequeRefusalReason';

    readonly action!: string;
    readonly definitive!: boolean;
    readonly description!: string;
}
